import { Schema } from "effect"
import { HttpApiEndpoint, HttpApiGroup } from "effect/http-api"
import { Authentication } from "./AuthApi.ts"
import { UnknownInstrument } from "./Errors.ts"
import { Instrument, InstrumentId } from "./MarketData.ts"

export class InstrumentsApi extends HttpApiGroup.make("instruments")
  .add(
    HttpApiEndpoint.get("search", "/search", {
      query: { q: Schema.String, limit: Schema.optional(Schema.Int) },
      success: Schema.Array(Instrument)
    }),
    HttpApiEndpoint.get("get", "/:id", {
      params: { id: InstrumentId },
      success: Instrument,
      error: UnknownInstrument
    })
  )
  .middleware(Authentication)
  .prefix("/instruments")
{}
